import { VentaActividad, Miembro } from '../lib/supabase';

export function getNombreCliente(
  pedido: VentaActividad,
  miembros: Miembro[]
): string {
  if (pedido.miembro_id) {
    const miembro = miembros.find(m => m.id === pedido.miembro_id);
    return miembro ? `${miembro.nombres} ${miembro.apellidos}` : 'Miembro';
  }

  return pedido.nombre_externo || 'Sin nombre';
}

export function esClienteExterno(pedido: VentaActividad): boolean {
  return !!pedido.nombre_externo;
}

export function tieneReferido(pedido: VentaActividad): boolean {
  return !!pedido.miembro_referido_id && esClienteExterno(pedido);
}

export function getNombreReferido(
  pedido: VentaActividad,
  miembros: Miembro[]
): string | null {
  if (!pedido.miembro_referido_id) return null;

  const referido = miembros.find(m => m.id === pedido.miembro_referido_id);
  return referido ? `${referido.nombres} ${referido.apellidos}` : null;
}

export function validarCliente(
  tipoCliente: 'miembro' | 'externo',
  miembroId?: string,
  nombreExterno?: string
): string | null {
  if (tipoCliente === 'miembro' && !miembroId) {
    return 'Debes seleccionar un miembro';
  }

  if (tipoCliente === 'externo' && !nombreExterno?.trim()) {
    return 'Debes ingresar el nombre del cliente';
  }

  return null;
}

/**
 * Deja solo los campos del tipo de cliente elegido y anula el resto.
 *
 * Los campos vacíos salen como `null`, nunca como `''`: `miembro_id` y
 * `miembro_referido_id` son columnas uuid, y un string vacío las hace fallar con
 * 400 ("invalid input syntax for type uuid"). `null` además borra el valor viejo
 * en un UPDATE, cosa que `undefined` no hace (se pierde al serializar el payload).
 */
export function limpiarCamposCliente(
  tipoCliente: 'miembro' | 'externo',
  data: {
    miembro_id?: string;
    nombre_externo?: string;
    miembro_referido_id?: string;
  }
): {
  miembro_id: string | null;
  nombre_externo: string | null;
  miembro_referido_id: string | null;
} {
  if (tipoCliente === 'miembro') {
    return {
      miembro_id: data.miembro_id || null,
      nombre_externo: null,
      miembro_referido_id: null
    };
  }

  return {
    miembro_id: null,
    nombre_externo: data.nombre_externo || null,
    miembro_referido_id: data.miembro_referido_id || null
  };
}
